import * as React from 'react';
import ReactResizeDetector from 'react-resize-detector';

export interface ILogoEditorImageProps {
  onEditorResize: (width: number, height: number) => void;
}

export class LogoEditorImage extends React.Component<ILogoEditorImageProps> {
  public render() {
    return (
      <div id="editorContainer" className="editor-canvas-container">
        <ReactResizeDetector
          handleHeight={true}
          handleWidth={true}
          onResize={(w, h) => {
            if (w && h) {
              this.props.onEditorResize(w, h)
            }
          }}
        >
          <div id="editor" className="center editor-canvas"/>
        </ReactResizeDetector>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/logo-app/logo-editor/logo-editor-controls/logo-editor-image.components.tsx